export const messages = {
  locationAlert: "Turn on Location Services to Allow 'Your Green Foods' to Determine Your Location by Clicking the Location icon in the Address bar, and then Always allow.",
};